"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useKeyV1UpNextGet = void 0;
exports.v1UpNextGetSetMock = v1UpNextGetSetMock;
exports.v1UpNextGet = v1UpNextGet;
exports.useQueryV1UpNextGet = useQueryV1UpNextGet;
exports.useInfiniteQueryV1UpNextGet = useInfiniteQueryV1UpNextGet;
const gateway_core_1 = require("@ifit/gateway-core");
const is_down_1 = require("./is-down");
let setMock;
let reactQuery;
function v1UpNextGetSetMock(mock) {
    setMock = mock;
}
async function v1UpNextGet(params) {
    if (!params) {
        params = {};
    }
    if (setMock) {
        return setMock(params);
    }
    const client = params.client || (0, gateway_core_1.getDefaultClient)();
    if (!client) {
        throw new Error('No @ifit/gateway-core GatewayApiClient has been constructed yet! Please do so before calling gateway methods, or pass a compatible client in the parameters.');
    }
    const requestURL = `/wolf-dashboard-service/v1/up-next`;
    const requestConfig = params.useM2MAuth
        ? await client.getM2MRequestConfig(params)
        : client.getRequestConfig(params);
    const headers = Object.assign(Object.assign({}, requestConfig.headers), params.headers);
    const queryParams = Object.assign({}, requestConfig.params);
    queryParams.softwareNumber = params.softwareNumber;
    queryParams.limit = params.limit;
    queryParams.challengeStoreEnabled = params.challengeStoreEnabled;
    queryParams.excludeItemTypes = params.excludeItemTypes;
    queryParams.includeItemTypes = params.includeItemTypes;
    queryParams.userType = params.userType;
    queryParams.isDiscoverableScheduled = params.isDiscoverableScheduled;
    if ((client.statusChecksEnabled || params.forceStatusCheck) && (await (0, is_down_1.wolfDashboardServiceIsDown)(client))) {
        return null;
    }
    const response = await client.req.send(requestURL, Object.assign(Object.assign({}, requestConfig), { headers, method: 'GET', params: queryParams }), params);
    return params.returnResponse
        ? response
        : response.data;
}
exports.useKeyV1UpNextGet = 'wolf-dashboard-service:v1UpNextGet:get';
function useQueryV1UpNextGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1UpNextGet, requestParams];
    return reactQuery.useQuery(key, queryFn, queryOptions);
}
function useInfiniteQueryV1UpNextGet(requestParams, queryOptions) {
    if (!reactQuery) {
        reactQuery = require('react-query');
    }
    const key = [exports.useKeyV1UpNextGet, requestParams];
    return reactQuery.useInfiniteQuery(key, queryFn, queryOptions);
}
function queryFn({ queryKey, pageParam }) {
    const [, params] = queryKey;
    const promise = v1UpNextGet(pageParam ? Object.assign(Object.assign({}, params), pageParam) : params);
    if (params === null || params === void 0 ? void 0 : params.cancelSource) {
        promise.cancel = () => {
            params.cancelSource.cancel('Query was cancelled by React Query');
        };
    }
    return promise;
}
//# sourceMappingURL=v1-up-next-get.js.map